module.exports = __webpack_public_path__ + "static/img/credenPhotofront.063a766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/credenPhotofront.png
// module id = deOl
// module chunks = 5